import Home from "./paginas/home/Home";

function App() {
  return (
    <Home />
  );
}

export default App;
